import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { api } from 'app/api'
import {
  GET_CAFETERIA_CUSTOMER_SELL_POINTS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cafeteria/customer/sale_points/get'

import type { Params, SellPoints } from '../../../../dataTypes/customer/sellPoints'

type Options = {
  autoload?: boolean
  params: Params
}

export function useSellPoints(options: Options) {
  const {
    autoload,
    params: { customerID, orgID },
  } = { autoload: true, ...options }
  const { t } = useTranslation('cafeteria')

  const [loading, setLoading] = useState(true)
  const [sellPoints, setSellPoints] = useState<SellPoints>({})

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_CAFETERIA_CUSTOMER_SELL_POINTS, {
      error: t('sale_points_fetch_error', 'Не удалось получить точки продаж') as string,
      params: {
        customerID,
        orgID,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    if (res) {
      setSellPoints(res)
    }
    setLoading(false)
  }, [customerID, orgID, t])

  useEffect(() => {
    if (autoload) {
      request()
    }
  }, [request, autoload])

  return { sellPoints, loading, request }
}
